// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Oool","title":"Info_title__19myH","links":"Info_links__2ghiM","link":"Info_link__atMj8","logo":"Info_logo__3pHfP"};